module.exports = __webpack_public_path__ + "img/logop2.6d845783.jpg";